import { useEffect } from 'react';

import { storeSelectedRegisterId } from './kioskStorage';

export function useKioskFormSync({
  activeBindings,
  availableOutboundRequestLoads,
  bindings,
  createRequestDirectionRef,
  currentActorName,
  currentRequest,
  requestLoadForm,
  selectedRegisterId,
  setCreateRequestDirection,
  setOperatorForm,
  setRequestLoadForm,
  setSelectedRegisterId,
  setSelectedRequestLoadId,
}) {
  useEffect(() => {
    if (bindings.length === 0) {
      return;
    }
    if (activeBindings.length === 0) {
      if (selectedRegisterId) {
        setSelectedRegisterId('');
      }
      return;
    }
    if (selectedRegisterId && !activeBindings.some((binding) => binding.registerId === selectedRegisterId)) {
      setSelectedRegisterId('');
    }
  }, [activeBindings, bindings.length, selectedRegisterId, setSelectedRegisterId]);

  useEffect(() => {
    storeSelectedRegisterId(selectedRegisterId);
  }, [selectedRegisterId]);

  useEffect(() => {
    setOperatorForm((current) => (
      current.operatorName === currentActorName
        ? current
        : { ...current, operatorName: currentActorName }
    ));
    setRequestLoadForm((current) => (
      current.createdBy === currentActorName
        ? current
        : { ...current, createdBy: currentActorName }
    ));
  }, [currentActorName, setOperatorForm, setRequestLoadForm]);

  useEffect(() => {
    setOperatorForm((current) => (
      current.confirmationNotes || current.returnQuantityPacks
        ? { ...current, confirmationNotes: '', returnQuantityPacks: '' }
        : current
    ));
  }, [currentRequest?.requestId, setOperatorForm]);

  useEffect(() => {
    if (!currentRequest?.requestId) {
      return;
    }

    const nextDirection = currentRequest.requestDirection === 'Inbound' ? 'Inbound' : 'Outbound';
    createRequestDirectionRef.current = nextDirection;
    setCreateRequestDirection(nextDirection);
  // Scanner stock state is authoritative: realtime updates can change the direction
  // of the same request after the pallet is identified.
  }, [
    currentRequest?.requestDirection,
    currentRequest?.requestId,
    createRequestDirectionRef,
    setCreateRequestDirection,
  ]);

  useEffect(() => {
    setSelectedRequestLoadId('');
  }, [currentRequest?.requestId, selectedRegisterId, setSelectedRequestLoadId]);

  useEffect(() => {
    if (
      requestLoadForm.direction !== 'Inbound'
      || !requestLoadForm.linkedOutboundLoadId
      || availableOutboundRequestLoads.some((requestLoad) => (
        requestLoad.loadId === requestLoadForm.linkedOutboundLoadId
      ))
    ) {
      return;
    }

    setRequestLoadForm((current) => (
      current.direction === 'Inbound'
        ? { ...current, linkedOutboundLoadId: '', name: '' }
        : current
    ));
  }, [
    availableOutboundRequestLoads,
    requestLoadForm.direction,
    requestLoadForm.linkedOutboundLoadId,
    setRequestLoadForm,
  ]);
}
